






import { Component, Prop, Vue } from "vue-property-decorator";
import TabResepObat from "@/components/pemeriksaan/TabResepObat.vue";

@Component({
  components: {
    TabResepObat,
  },
})
export default class ResepObatTabView extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
}
